import Vue from 'vue';
import { UndergradLesson } from '@/models/undergrad/undegrad-lesson.model';

import { MutationTree } from 'vuex';
import { UndergradDisciplineState } from '@/store/undergrad/disciplines-instances/state';
import { UndergradLive } from '@/models/undergrad/undergrad-live.model';

interface NormalizedDisciplinesLessons {
  undergradLessons: {
    [key: string]: UndergradLesson;
  };
}

interface NormalizedDisciplinesLives {
  undergradLives: {
    [key: string]: UndergradLive;
  };
}

const mutations: MutationTree<UndergradDisciplineState> = {
  SET_DISCIPLINES_INSTANCES_IDS(state: UndergradDisciplineState, disciplinesIds: string[]) {
    state.allDisciplinesIds = disciplinesIds;
  },
  SET_DISCIPLINES(state: UndergradDisciplineState, entities: UndergradDisciplineState) {
    if (!entities.undergradDisciplines) {
      state.undergradDisciplines = {};
      return;
    }

    state.undergradDisciplines = entities.undergradDisciplines;
  },
  SET_CURRENT_DISCIPLINES(state: UndergradDisciplineState, disciplineIds: string[]) {
    if (!disciplineIds || !disciplineIds.length) {
      state.currentDisciplinesByCycle = [];
      return;
    }

    state.currentDisciplinesByCycle = disciplineIds.map(
      (id: string) => state.undergradDisciplines[id],
    );
  },
  SET_LOADING_DISCIPLINE_DATA(state, payload: { isLoading: boolean; disciplineId: string }) {
    const { isLoading, disciplineId } = payload;

    Vue.set(state.isLoadingDisciplineData, disciplineId, isLoading);
  },
  SET_LOADING_DISCIPLINE_LIVES(state, payload: { isLoading: boolean; disciplineId: string }) {
    const { isLoading, disciplineId } = payload;

    Vue.set(state.isLoadingDisciplineLives, disciplineId, isLoading);
  },
  SET_LOADING_HOME_DISCIPLINES_LIVES(
    state,
    payload: { disciplinesIds: string[]; isLoading: boolean },
  ) {
    const { isLoading, disciplinesIds } = payload;

    disciplinesIds.forEach((disciplineId: string) => {
      Vue.set(state.isLoadingDisciplineLives, disciplineId, isLoading);
    });
  },
  SET_DISCIPLINE_LESSONS(
    state,
    payload: { disciplineId: string; entities: NormalizedDisciplinesLessons },
  ) {
    const { entities, disciplineId } = payload;
    Vue.set(state.undergradDisciplines, disciplineId, {
      ...state.undergradDisciplines[disciplineId],
      lessons: entities.undergradLessons,
    });
  },
  SET_DISCIPLINE_LIVES(
    state,
    payload: { disciplineId: string; entities: NormalizedDisciplinesLives },
  ) {
    const { entities, disciplineId } = payload;

    if (!entities.undergradLives) {
      state.undergradDisciplines[disciplineId].lives = {};
      return;
    }

    Vue.set(state.undergradDisciplines, disciplineId, {
      ...state.undergradDisciplines[disciplineId],
      lives: entities.undergradLives,
    });
  },
};

export default mutations;
